<template>
<div id="ownership-bar" class="bar_graph">
  <dl>
    <dt>
      Ownership Types
    </dt>
    <dd v-for="type in types" v-bind:key="type.name" v-bind:class="'percentage percentage-' + type.percentage">
      <span class="text">{{ type.name }}<span>{{ type.count }} ({{ type.percentage }}%)</span></span>
    </dd>
  </dl>
</div>
</template>

<script>
export default {
  name: 'OwnershipTypesBar',
  computed: {
    types () {
      return this.$store.getters.typesBar
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/bar_ownership.vue